import React, { useState, useEffect } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { aigeneratedStoriesDetail } from "../../../api/aiStoriesServices";
// import bookimg from '../../assets/img/characterimg1.jpg';
import bookimg from '../../../assets/img/taleimg1.jpg'
export default function ViewAIGeneratedStories() {
  const { storyId } = useParams();
  const [stories, setStories] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [characterModal, setCharacterModal] = useState(false);

  const fetchAigeneratedStoriesDetail = async () => {
  try {
    console.log('==wwww====req.params',storyId)
    const payload = {
      storiesId:storyId,
    }
    const response = await aigeneratedStoriesDetail(payload);
    console.log("=== stories detail ddddresponse ===", response);
    if (response.status) {
      setStories(response.data);
    }
  } catch (error) {
    console.error("Failed to fetch stories details:", error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchAigeneratedStoriesDetail();
  }, [storyId]);

  return (
    <>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between">
          <h5>AI-Generated Story Details</h5>
          <Button as={Link} to="/ai-generated-tales" className="btn btn-primary-light px-4 min_width140">
            Back
          </Button>
        </Card.Header>

        <Card.Body className="taledtl_div mt-3">
          <Row className="g-3 mb-4">
            <Col md="4">
              <div className="talefile_box">
                <img
                  className="talefile_img"
                  onClick={() => setShow(true)}
                  src={stories?.thumbnail || bookimg}
                  alt="Story Thumbnail"
                />
              </div>
            </Col>

            <Col md="8">
              <div className="talefile_list">
                <div className="tablefilelist_grid">
                  <h4>Title</h4>
                  <p>{stories?.title || "N/A"}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Description</h4>
                  <p>{stories?.description || "N/A"}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Slug</h4>
                  <p>{stories?.slug || "N/A"}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Tale from</h4>
                  <p>{stories?.taleFrom || "N/A"}</p>
                </div>
                
                <div className="tablefilelist_grid">
                  <h4>Status</h4>
                  <p>{stories?.status || "N/A"}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Modal className="modal_video" show={show} onHide={() => setShow(false)} centered>
        <Modal.Body>
          <img
            src={stories?.thumbnail || "https://via.placeholder.com/600"}
            alt="Story Thumbnail"
            style={{ width: "100%" }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
